__webpack_require__.p = "/~19_kwiecien/licencjat/";